import React from 'react'
import styles from './UserSummary.module.css'

const UserSummary = props => {
  let wins = 0
  let losses = 0
  let totalGuesses = 0
  let totalCorrectGuesses = 0
  
  props.gamesPlayed.forEach(game => {
    wins += game.outcome
    if (game.outcome === 0) {
      losses++
    }
    totalGuesses += game.correctGuesses + game.incorrectGuesses
    totalCorrectGuesses += game.correctGuesses
  })
  
  let battingAverage = 0
  if (props.gamesPlayed.length) {
    battingAverage = totalCorrectGuesses / totalGuesses
  }
  return (
    <section className={styles.stats}>
      <h1>User Stats</h1>
      <div className={styles.statsItems}>
        <div className={styles.record}>
          <h3>Record: ({wins}-{losses})</h3>
          <div>
            <h4>{wins} wins</h4>
            <h4>{losses} losses</h4>
          </div>
        </div>
        <div className={styles.average}>
          <h3>"Batting Average"</h3>
          <div>
            <h4>{String(battingAverage.toFixed(3))}</h4>
          </div>
          <p>* Total correct guesses divided by total guesses</p>
        </div>
      </div>
    </section>
  )
}

export default UserSummary